import { apiSlice } from "../apiSlice";

export interface GetRestaurantResponse {
  items: any;
}

export interface GetSearchRequest {
  params: string;
}

export interface UpdateRestaurantStatusRequest {
  restaurantId: string;
  status: string;
}

export interface RestaurantImageUpdateRequest {
  imageRef: string;
  restId?: string;
  oldImgUrl: string;
}

export type LogoFileExtntionRequest = {
  fileExtention: string;
};

export type LogoFileExtntionResponse = {
  result: {
    imageReference: string;
    imageUploadUrl: string;
  };
};

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;

export const restaurantSearchService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRestaurants: builder.query({
      query: () =>
        `https://superadminhttps-getallrestaurants-${API_BASE_DOMAIN}-uc.a.run.app?status=All`,
    }),
    getAllRestaurantsByStatus: builder.query({
      query: (restaurantStatus) =>
        `https://superadminhttps-getallrestaurants-${API_BASE_DOMAIN}-uc.a.run.app?status=${restaurantStatus}&sortDisplay=false&order=desc`,
    }),
    getRestaurantsByStatus: builder.mutation<
      GetRestaurantResponse,
      { restaurantStatus: string }
    >({
      query: ({ restaurantStatus }) =>
        `https://superadminhttps-getallrestaurants-${API_BASE_DOMAIN}-uc.a.run.app?status=${restaurantStatus}&sortDisplay=false&order=desc`,
    }),
    getRestaurantSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/RestaurantSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id": `${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key":
            `${ALGOLIA_API_KEY}`,
        },
      }),
    }),
    updateRestaurantStatus: builder.mutation<
      any,
      UpdateRestaurantStatusRequest
    >({
      query: ({ restaurantId, status }) => ({
        url: `https://superadminhttps-updaterestaurantstatus-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "PUT",
        body: {
          restaurantId,
          status,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    getRestaurantDetailsById: builder.query({
      query: (restaurantId) =>
        `https://adminhttps-getrestaurantsbyrestaurantid-${API_BASE_DOMAIN}-uc.a.run.app/?restaurantId=${restaurantId}`,
    }),
    updateRestaurantImage: builder.mutation<any, RestaurantImageUpdateRequest>({
      query: (data) => ({
        url: `https://adminhttps-updaterestaurantimage-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),
    UploadRestaurantLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getrestaurantlogouploadurl-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
      }),
    }),
    UploadMenuItemLogoFileExtntionHttps: builder.mutation<
      LogoFileExtntionResponse,
      LogoFileExtntionRequest
    >({
      query: (data) => ({
        url: `https://adminhttps-getmenuitemimageuploadurl-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "POST",
        body: data,
      }),
    }),
    getOwnerSearchResults: builder.mutation<GetSearchRequest, any>({
      query: (data) => ({
        url: `https://${ALGOLIA_APP_ID}-dsn.algolia.net/1/indexes/UserSearchDocuments/query`,
        method: "POST",
        body: data,
        headers: {
          "X-Algolia-Application-Id":`${ALGOLIA_APP_ID}`,
          "X-Algolia-API-Key":  `${ALGOLIA_API_KEY}`,
        },
      }),
    }),
  }),
});

export const {
  useGetAllRestaurantsQuery,
  useLazyGetAllRestaurantsQuery,
  useGetRestaurantsByStatusMutation,
  useGetAllRestaurantsByStatusQuery,
  useLazyGetAllRestaurantsByStatusQuery,
  useGetRestaurantSearchResultsMutation,
  useUpdateRestaurantStatusMutation,
  useGetRestaurantDetailsByIdQuery,
  useLazyGetRestaurantDetailsByIdQuery,
  useUpdateRestaurantImageMutation,
  useUploadRestaurantLogoFileExtntionHttpsMutation,
  useUploadMenuItemLogoFileExtntionHttpsMutation,
  useGetOwnerSearchResultsMutation,
} = restaurantSearchService;
